import { useState, useEffect } from "react";
import { useParams, useNavigate, NavLink } from "react-router-dom";
import { useCart } from "./context/CartContext";
import { BASE_URL } from "./baseurl";

export default function ProductPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const [product, setProduct] = useState(null);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [quantity, setQuantity] = useState(1);
  const [activeTab, setActiveTab] = useState("description");
  const [currentUserId, setCurrentUserId] = useState(null);

  const [isZooming, setIsZooming] = useState(false);
const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0 });


  
  const [reviews, setReviews] = useState([]);
  const [avgRating, setAvgRating] = useState(0);
  const [reviewsLoading, setReviewsLoading] = useState(true);
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [reviewText, setReviewText] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [reviewError, setReviewError] = useState(null);
  

  
  const [editingId, setEditingId] = useState(null);
  const [editText, setEditText] = useState("");
  const [editRating, setEditRating] = useState(0);

  const getCurrentUserId = () => {
    
    return localStorage.getItem("userId");
  };

  const getAuthHeader = () => {
    const token = localStorage.getItem("token");
    return { Authorization: `Bearer ${token}` };
  };

  useEffect(() => {
    const fetchCurrentUser = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const res = await fetch(`${BASE_URL}/auth/me`, {
          headers: getAuthHeader(),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || "Failed to fetch current user");

        setCurrentUserId(data.id);
      } catch (err) {
        console.error("Fetch current user error:", err);
      }
    };

    fetchCurrentUser();
    
  }, []);

  useEffect(() => {
    const fetchProduct = async () => {
      setLoading(true);
      setError(null);
      try {
        const [itemRes, allRes] = await Promise.all([
          fetch(`${BASE_URL}/items/${id}`),
          fetch(`${BASE_URL}/items`),
        ]);

        const itemData = await itemRes.json();
        const allData = await allRes.json();

        if (!itemRes.ok) throw new Error(itemData.message || "Failed to fetch item");

        setProduct(itemData.item);
        setRelatedProducts(
          (allData.items || []).filter((p) => p._id !== id).slice(0, 5)
        );
      } catch (err) {
        console.error("Fetch product error:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  const fetchReviews = async () => {
    setReviewsLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/reviews/item/${id}`);
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to fetch reviews");
    console.log(data.reviews)
    console.log("REVIEWS")
      setReviews(data.reviews || []);
      setAvgRating(data.avgRating || 0);
    } catch (err) {
      console.error("Fetch reviews error:", err);
    } finally {
      setReviewsLoading(false);
    }
  };

  useEffect(() => {
    fetchReviews();
    
  }, [id]);

  const handleAddToCart = () => {
    addToCart(product);
  };

  const handleSubmitReview = async () => {
    setReviewError(null);

    if (!rating) {
      setReviewError("Please select a rating.");
      return;
    }
    if (!reviewText.trim()) {
      setReviewError("Please write a review.");
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      setReviewError("You need to be signed in to leave a review.");
      return;
    }

    setSubmitting(true);
    try {
      const res = await fetch(`${BASE_URL}/reviews`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeader(),
        },
        body: JSON.stringify({ review: reviewText, starts: rating, item: id }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to submit review");

      setReviewText("");
      setRating(0);
      await fetchReviews();
    } catch (err) {
      setReviewError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  const startEditing = (rev) => {
    setEditingId(rev._id);
    setEditText(rev.review);
    setEditRating(rev.starts);
  };

  const cancelEditing = () => {
    setEditingId(null);
    setEditText("");
    setEditRating(0);
  };

  const handleUpdateReview = async (reviewId) => {
    try {
      const res = await fetch(`${BASE_URL}/reviews/${reviewId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeader(),
        },
        body: JSON.stringify({ review: editText, starts: editRating }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to update review");

      cancelEditing();
      await fetchReviews();
    } catch (err) {
      console.error("Update review error:", err);
      alert(err.message);
    }
  };

  const handleDeleteReview = async (reviewId) => {
    if (!window.confirm("Delete this review?")) return;

    try {
      const res = await fetch(`${BASE_URL}/reviews/${reviewId}`, {
        method: "DELETE",
        headers: getAuthHeader(),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to delete review");

      await fetchReviews();
    } catch (err) {
      console.error("Delete review error:", err);
      alert(err.message);
    }
  };

  if (loading) {
    return (
      <div className="w-full bg-white py-24 px-6 md:px-16 text-center text-gray-500">
        Loading product...
      </div>
    );
  }

  if (error || !product) {
    return (
      <div className="w-full bg-white py-24 px-6 md:px-16 text-center text-gray-500">
        Product not found.
      </div>
    );
  }

 

  return (
    <div className="w-full bg-white pt-40 pb-12 px-6 md:px-16">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid md:grid-cols-2 gap-10">
        <div
  className="relative bg-gray-100 rounded-lg overflow-hidden flex items-center justify-center h-[400px] cursor-zoom-in"
  onMouseEnter={() => product.image && setIsZooming(true)}
  onMouseLeave={() => setIsZooming(false)}
  onMouseMove={(e) => {
    if (!product.image) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setZoomPosition({ x, y });
  }}
>
  <button
    onClick={(e) => {
      e.stopPropagation();
      setIsZooming((z) => !z);
    }}
    className={`absolute top-4 right-4 z-10 w-9 h-9 rounded-full bg-white border border-gray-200 flex items-center justify-center hover:text-teal-500 transition-colors ${
      isZooming ? "text-teal-500" : "text-gray-500"
    }`}
  >
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.5" />
      <path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      {isZooming && (
        <>
          <path d="M9 11h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </>
      )}
    </svg>
  </button>

  {product.image ? (
    <>
      <img
        src={`${BASE_URL.replace(/\/api$/, "")}${product.image}`}
        alt={product.title}
        className="w-full h-full object-cover"
      />

      {isZooming && (
        <div
          className="absolute inset-0 pointer-events-none bg-no-repeat"
          style={{
            backgroundImage: `url(${BASE_URL.replace(/\/api$/, "")}${product.image})`,
            backgroundSize: "200%",
            backgroundPosition: `${zoomPosition.x}% ${zoomPosition.y}%`,
          }}
        />
      )}
    </>
  ) : (
    <svg width="80" height="80" viewBox="0 0 24 24" fill="none" className="text-gray-300" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="9" cy="9" r="1.5" fill="currentColor" />
      <path d="M21 15l-5-5-9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )}
</div>
          <div>
            <div className="flex items-center gap-2 text-[15px] text-gray-500 mb-3">
              <NavLink to="/" className="hover:text-teal-500">Home</NavLink>
              <span>/</span>
              <span className="hover:text-teal-500">Shop</span>
              <span>/</span>
              <span className="text-teal-500">{product.title}</span>
            </div>

            <h1 className="text-gray-800 font-semibold text-[30px]">{product.title}</h1>

            {reviews.length > 0 && (
              <div className="flex items-center gap-2 mt-2">
                <div className="flex gap-0.5">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <svg
                      key={star}
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill={avgRating >= star ? "currentColor" : "none"}
                      className={avgRating >= star ? "text-teal-500" : "text-gray-300"}
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ))}
                </div>
                <span className="text-gray-500 text-[14px]">
                  {avgRating.toFixed(1)} ({reviews.length} review{reviews.length !== 1 ? "s" : ""})
                </span>
              </div>
            )}

            <p className="text-teal-600 font-bold text-[25.5px] mt-3">
              ${Number(product.price).toFixed(2)}
            </p>

            <p className="text-gray-500 text-[15px] mt-2">
              {product.description?.slice(0, 80)}
            </p>

            <p className="text-gray-600 text-[17px] mt-6">
              <span className="font-semibold text-gray-800">Availability:</span>{" "}
              <span className="text-teal-600">In stock</span>
            </p>

            <div className="flex items-center gap-4 mt-6">
              <div className="flex items-center border border-gray-300 rounded-full">
                <button
                  onClick={() => setQuantity((q) => Math.max(1, q - 1))}
                  className="w-9 h-9 flex items-center justify-center text-gray-600 hover:text-teal-600 text-[17px]"
                >
                  -
                </button>
                <span className="w-10 text-center text-gray-800 text-[17px]">
                  {quantity}
                </span>
                <button
                  onClick={() => setQuantity((q) => q + 1)}
                  className="w-9 h-9 flex items-center justify-center text-gray-600 hover:text-teal-600 text-[17px]"
                >
                  +
                </button>
              </div>

              <button
                onClick={handleAddToCart}
                className="border border-teal-500 text-teal-600 rounded-full px-8 py-2 text-[17px] font-medium hover:bg-teal-500 hover:text-white transition-colors"
              >
                ADD TO CART
              </button>
            </div>

            <div className="border-t border-gray-200 mt-8 pt-6 flex items-center gap-2 text-[15px] text-gray-500">
              <span>
                <span className="font-semibold text-gray-700">SKU:</span> {product._id}
              </span>
              <span className="text-gray-300">|</span>
              <span>
                <span className="font-semibold text-gray-700">Category:</span>{" "}
                Compounds
              </span>
            </div>
          </div>
        </div>

        <div className="mt-16">
          <div className="flex gap-8 border-b border-gray-200">
            <button
              onClick={() => setActiveTab("description")}
              className={`pb-3 text-[17px] ${
                activeTab === "description"
                  ? "text-gray-800 border-b-2 border-teal-500"
                  : "text-gray-400 hover:text-gray-600"
              }`}
            >
              Description
            </button>
            <button
              onClick={() => setActiveTab("reviews")}
              className={`pb-3 text-[17px] ${
                activeTab === "reviews"
                  ? "text-gray-800 border-b-2 border-teal-500"
                  : "text-gray-400 hover:text-gray-600"
              }`}
            >
              Reviews ({reviews.length})
            </button>
          </div>

          {activeTab === "description" && (
            <div className="mt-6 text-gray-600 text-[15px] leading-relaxed whitespace-pre-line">
              {product.description}
            </div>
          )}

          {activeTab === "reviews" && (
            <div className="mt-6">
              {reviewsLoading ? (
                <p className="text-gray-500 text-[15px]">Loading reviews...</p>
              ) : reviews.length === 0 ? (
                <p className="text-gray-500 text-[15px]">There are no reviews yet.</p>
              ) : (
                <div className="space-y-6 max-w-2xl">
                  {reviews.map((rev) => {
                    const isMine = currentUserId && rev.user?._id === currentUserId;
                    const isEditing = editingId === rev._id;

                    return (
                      <div key={rev._id} className="border-b border-gray-100 pb-6">
                        {isEditing ? (
                          <div>
                            <div className="flex gap-1 mb-2">
                              {[1, 2, 3, 4, 5].map((star) => (
                                <button key={star} onClick={() => setEditRating(star)}>
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill={editRating >= star ? "currentColor" : "none"}
                                    className={editRating >= star ? "text-teal-500" : "text-gray-300"}
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </button>
                              ))}
                            </div>
                            <textarea
                              value={editText}
                              onChange={(e) => setEditText(e.target.value)}
                              rows={3}
                              className="w-full bg-gray-50 border border-gray-200 rounded-md px-3 py-2 text-gray-800 text-[15px] focus:outline-none focus:ring-2 focus:ring-teal-400"
                            />
                            <div className="flex gap-3 mt-2">
                              <button
                                onClick={() => handleUpdateReview(rev._id)}
                                className="text-teal-600 text-[14px] font-medium hover:underline"
                              >
                                Save
                              </button>
                              <button
                                onClick={cancelEditing}
                                className="text-gray-500 text-[14px] hover:underline"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <div className="flex items-center justify-between">
                              <div className="flex gap-0.5">
                                {[1, 2, 3, 4, 5].map((star) => (
                                  <svg
                                    key={star}
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill={rev.starts >= star ? "currentColor" : "none"}
                                    className={rev.starts >= star ? "text-teal-500" : "text-gray-300"}
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                ))}
                              </div>

                              {isMine && (
                                <div className="flex gap-3">
                                  <button
                                    onClick={() => startEditing(rev)}
                                    className="text-gray-500 text-[13px] hover:text-teal-600"
                                  >
                                    Edit
                                  </button>
                                  <button
                                    onClick={() => handleDeleteReview(rev._id)}
                                    className="text-gray-500 text-[13px] hover:text-red-500"
                                  >
                                    Delete
                                  </button>
                                </div>
                              )}
                            </div>

                            <p className="text-gray-700 text-[15px] mt-2">{rev.review}</p>
                            <p className="text-gray-400 text-[13px] mt-1">
                              {rev.user?.email || "Anonymous"}
                            </p>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}

              <div className="border border-gray-200 rounded-lg p-6 mt-8 max-w-2xl">
                <h3 className="text-gray-800 text-[17px] font-semibold">
                  Leave a review for "{product.title}"
                </h3>

                {reviewError && (
                  <p className="text-red-500 text-[14px] mt-2">{reviewError}</p>
                )}

                <p className="text-gray-600 text-[15px] mt-6">Your rating *</p>
                <div className="flex gap-1 mt-2">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <button
                      key={star}
                      onClick={() => setRating(star)}
                      onMouseEnter={() => setHoverRating(star)}
                      onMouseLeave={() => setHoverRating(0)}
                      className="text-2xl"
                    >
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill={(hoverRating || rating) >= star ? "currentColor" : "none"}
                        className={
                          (hoverRating || rating) >= star ? "text-teal-500" : "text-gray-300"
                        }
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  ))}
                </div>

                <label className="block text-gray-600 text-[15px] mt-6">Your review *</label>
                <textarea
                  value={reviewText}
                  onChange={(e) => setReviewText(e.target.value)}
                  rows={4}
                  className="w-full mt-2 bg-gray-50 border border-gray-200 rounded-md px-3 py-2 text-gray-800 text-[15px] focus:outline-none focus:ring-2 focus:ring-teal-400"
                />

                <button
                  onClick={handleSubmitReview}
                  disabled={submitting}
                  className="mt-6 border border-gray-300 text-gray-600 rounded-full px-8 py-2 text-[15px] hover:bg-teal-500 hover:border-teal-500 hover:text-white transition-colors disabled:opacity-50"
                >
                  {submitting ? "SUBMITTING..." : "SUBMIT"}
                </button>
              </div>
            </div>
          )}
        </div>

        {relatedProducts.length > 0 && (
          <div className="mt-20">
            <h2 className="text-gray-800 font-semibold text-[28px] mb-8">
              Related products
            </h2>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              {relatedProducts.map((related) => (
                <div
                  key={related._id}
                  onClick={() => navigate(`/product/${related._id}`)}
                  className="cursor-pointer group"
                >
                  <div className="relative bg-gray-50 border border-gray-200 rounded-lg overflow-hidden w-full h-[260px] flex items-center justify-center">
                    {related.image ? (
                      <img
                        src={`${BASE_URL.replace(/\/api$/, "")}${related.image}`}
                        alt={related.title}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <svg width="60" height="60" viewBox="0 0 24 24" fill="none" className="text-gray-300" xmlns="http://www.w3.org/2000/svg">
                        <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="1.5" />
                        <circle cx="9" cy="9" r="1.5" fill="currentColor" />
                        <path d="M21 15l-5-5-9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    )}

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        addToCart(related);
                      }}
                      className="absolute bottom-3 right-3 w-9 h-9 rounded-full bg-white border border-gray-300 flex items-center justify-center text-gray-600 opacity-0 group-hover:opacity-100 transition-opacity hover:bg-teal-500 hover:text-white hover:border-teal-500"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="826 837.5 140 121">
                        <path
                          fill="currentColor"
                          d="M878.77,943.611c0,2.75-1.005,5.131-3.015,7.141c-2.009,2.01-4.389,3.014-7.139,3.014c-2.75,0-5.13-1.004-7.139-3.014  c-2.01-2.01-3.015-4.391-3.015-7.141c0-2.749,1.005-5.129,3.015-7.138c2.009-2.011,4.389-3.016,7.139-3.016  c2.75,0,5.13,1.005,7.139,3.016C877.765,938.482,878.77,940.862,878.77,943.611z M949.846,943.611c0,2.75-1.005,5.131-3.015,7.141  s-4.39,3.014-7.141,3.014c-2.748,0-5.129-1.004-7.138-3.014c-2.01-2.01-3.015-4.391-3.015-7.141c0-2.749,1.005-5.129,3.015-7.138  c2.009-2.011,4.39-3.016,7.138-3.016c2.751,0,5.131,1.005,7.141,3.016C948.841,938.482,949.846,940.862,949.846,943.611z   M960,857.306v40.615c0,1.27-0.438,2.393-1.311,3.371s-1.943,1.548-3.212,1.705l-82.815,9.678c0.687,3.174,1.031,5.024,1.031,5.554  c0,0.846-0.635,2.539-1.904,5.076h72.979c1.375,0,2.564,0.503,3.569,1.508c1.006,1.005,1.508,2.194,1.508,3.569  c0,1.376-0.502,2.564-1.508,3.569c-1.005,1.005-2.194,1.507-3.569,1.507H863.54c-1.375,0-2.565-0.502-3.57-1.507  s-1.507-2.193-1.507-3.569c0-0.581,0.212-1.415,0.634-2.498c0.424-1.085,0.847-2.036,1.27-2.855c0.423-0.82,0.992-1.878,1.706-3.174  s1.124-2.076,1.23-2.34l-14.041-65.285h-16.183c-1.375,0-2.564-0.502-3.569-1.507c-1.005-1.005-1.508-2.195-1.508-3.57  c0-1.375,0.502-2.565,1.508-3.57c1.004-1.004,2.194-1.507,3.569-1.507h20.308c0.846,0,1.6,0.172,2.261,0.516  s1.177,0.754,1.547,1.229c0.37,0.476,0.714,1.124,1.032,1.944c0.316,0.819,0.528,1.507,0.634,2.062  c0.106,0.556,0.252,1.336,0.437,2.34c0.185,1.005,0.304,1.692,0.357,2.063h95.271c1.375,0,2.563,0.502,3.57,1.507  C959.497,854.741,960,855.931,960,857.306z"
                        />
                      </svg>
                    </button>
                  </div>

                  <h3 className="text-gray-700 font-medium text-[16px] mt-4 text-center">
                    {related.title}
                  </h3>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}